import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../includes/Header';
import Footer from '../../includes/Footer';
import { Container, Row, Col } from 'react-bootstrap';
import { getCategory } from '../../apiservices/ApiServices';
import Loader from '../../components/Loader/Loader';
import CategoryCard from '../../components/CategoryCard/CategoryCard';
import { ToastContainer, toast } from 'react-toastify';

const Categories = () => {
    const [isLoading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    const getCategorys = async () => {
        setLoading(true);
        try {
            const res = await getCategory();
            setData(res.data.data)
            setLoading(false);
        } catch (error) {
            setLoading(false);
            setData(error.response.data.data)
        }
    };

    useEffect(() => {
        getCategorys();
    }, [])

    return (
        <>
            <Header toast={toast} />
            <ToastContainer />
            {isLoading ? (<Loader />) : (
                <>
                    <div className="crumbsec">
                        <div className="wrap">
                            <Link to={'/'}>Home</Link>
                            <span className="sep">&rsaquo;</span>
                            <span className="cur">categories</span>
                        </div>
                    </div>

                    <section id='collections'>
                        <div className='collections-block'>
                            <Container>
                                <div className='product-box'>
                                    <Row>
                                        {Array.isArray(data) && data.map((item) => (
                                            <Col md={4} key={`catid_${item.id}`}>
                                                <CategoryCard
                                                    Name={item.name}
                                                    ImgUrl={item.image_url}
                                                    CatSlug={item.slug}
                                                    ProCount={item.product_count}
                                                    Childs={item.childs}
                                                />
                                            </Col>
                                        ))}
                                    </Row>
                                </div>
                            </Container>
                        </div>
                    </section>
                </>
            )}

            <Footer toast={toast} />
        </>
    )
}

export default Categories